"use client";

import React, { useRef } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useGetAllOfferCards } from "@/apis/Overall/Queries";
import { CATEGORIES } from "@/lib/Constants";

const TopBanner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: response } = useGetAllOfferCards();
  const offercardData = response?.data;

  // Embla carousel for offer banner
  const autoplayPlugin = useRef(
    Autoplay({ delay: 5000, stopOnInteraction: false })
  );
  const [emblaRef] = useEmblaCarousel({ loop: true }, [autoplayPlugin.current]);

  const handleViewAllClick = (offerId?: string) => {
    if (offerId) {
      navigate(`/offer-card/${offerId}`);
    } else {
      navigate(CATEGORIES);
    }
  };

  if (!offercardData || offercardData.length === 0) {
    return null;
  }

  return (
    <div className="hidden md:block bg-gradient-to-r from-red-600 to-red-700 text-white shadow-sm py-2">
      <div className="overflow-hidden w-full max-w-4xl mx-auto" ref={emblaRef}>
        <div className="flex">
          {offercardData?.slice(0, 3).map((section: any) => (
            <div key={section._id} className="flex-[0_0_100%] min-w-0">
              <div className="flex items-center justify-center gap-4 text-center px-4 py-1">
                <p className="font-semibold text-sm sm:text-base md:text-lg truncate">
                  {section.title}
                </p>
                <p
                  className="underline decoration-2 underline-offset-2 hover:decoration-white cursor-pointer whitespace-nowrap text-sm sm:text-base"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewAllClick(section._id);
                  }}
                >
                  {t("viewCollection")}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
